import { Box } from '@mui/material';
import type { ReactElement } from 'react';
import { useState } from 'react';
import type { IRecordPerPage } from '../../../types';
import { ERecordLength } from '../../data/Constants';
import { RecordLengthPicker } from '../RecordLengthPicker';

/**
 * RecrodsPerPage is be set for Pdm landing page and Procos Page.
 * @param {IRecordPerPage} props is the callback actions
 * @returns JSX
 */

const RecordsPerPage = (props: IRecordPerPage): ReactElement => {
  const [recordsPerPage, setRecordsPerPage] = useState(props?.value ?? ERecordLength.RL15);

  /**
   * This function set the selected record
   * @param e is the current elemnt for the selected value
   */

  const handleRecordsChange = (e): void => {
    props.handleRecordsChange(e.target.value);
    setRecordsPerPage(e.target.value);
  };

  return (
    <Box className="recordsChange-conatiner">
      <RecordLengthPicker limit={recordsPerPage} handleRecordsChange={handleRecordsChange} />
    </Box>
  );
};

export default RecordsPerPage;
